__turbopack_context__.v({
  "active": "SegmentedControl-module__sTtLra__active",
  "container": "SegmentedControl-module__sTtLra__container",
  "option": "SegmentedControl-module__sTtLra__option",
});
